/** Quiet full-page placeholder while a page, the session or a project loads. */
export function LoadingState({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className="ls-loading" role="status">
      <img src="/brand/logo.svg" alt="" />
      <span>{label}</span>
    </div>
  )
}
